import { useRecoilValue } from 'recoil';

import { confirmedGuardianDocument } from '../atoms/confirmedGuardianDocument';

export default function useConfirmedGuardianDocument() {
  return useRecoilValue(confirmedGuardianDocument);
}
